/**
 * Created by ken on 2018/11/5.
 */
import * as types from '../mutation_types';
const Utils = require('../../lib/utils')

let userInfo;
try {
    userInfo = JSON.parse(Utils.getCookie('user'));
} catch (err) {
    //console.log(err.message);
} finally {
    if (!userInfo) {
        userInfo = {};
    }
}

let permissions;
try {
    permissions = JSON.parse(Utils.getCookie('permissions'));
} catch (err) {
    //console.log(err.message);
} finally {
    if (!permissions) {
        permissions = [];
    }
}
const state = {
    userInfo: userInfo,
    permissions: permissions
};

const getters = {

};

const actions = {
    setUserInfo({
        commit
    }, userInfo) {
        Utils.setCookie('user', JSON.stringify(userInfo));
        commit(types.SET_USERINFO, userInfo);
    },

    setPermissions({
        commit
    }, permissions) {
        return new Promise((resolve, reject) => {
            Utils.setCookie('permissions', JSON.stringify(permissions));
            commit(types.SET_PERMISSIONS, permissions);

            resolve();
        })
    }
};

const mutations = {
    [types.SET_PERMISSIONS](state, permissions) {
        state.permissions = permissions;
    },
    [types.SET_USERINFO](state, userInfo) {
        state.userInfo = userInfo;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.js